import { ClinicsYandexMap } from '../lib/ClinicsYandexMap';
import { ClinicsGoogleMap } from '../lib/ClinicsGoogleMap';

export async function initClinicsMap(mapEl, options = {}) {
  const mapApiKey = window.wpParams.map_api_key ?? null;
  const mapProvider = window.wpParams.map_provider ?? null;
  const isClusteringEnabled = window.wpParams.map_enable_clustering ?? false;

  let map;
  if (mapProvider === 'google') {
    map = new ClinicsGoogleMap(mapEl, {
      googleMapId: window.wpParams.map_id ?? 'DEMO_MAP_ID',
      cluster: { enabled: isClusteringEnabled },
      ...options,
    });
    await map.init();
  } else if (mapProvider === 'yandex') {
    map = new ClinicsYandexMap(mapEl, {
      apiKey: mapApiKey,
      cluster: { enabled: isClusteringEnabled },
      ...options,
    });
    await map.init();
  } else {
    console.error(
      'Unknown map provider, see: Admin -> Site settings -> Admin settings -> Map',
    );
  }

  return map;
}
